import React, { Component } from 'react';
import {
  GET_COMPETITION_BY_ID,
  GET_NOMINATIONS_FOR_PUBLIC_VOTING,
  EMAIL_PUBLIC_VOTE,
  FACEBOOK_PUBLIC_VOTE,
  GET_PUBLIC_NOMINATION_BY_ID
} from './queries-mutations';
import { get, debounce } from 'lodash';
import { compose, Mutation, Query } from 'react-apollo';
import { renameObjectForSelect } from '../../constants/helper';
import { FaUser, FaFacebookF, FaShare } from 'react-icons/fa';
import { AiOutlineMail } from "react-icons/ai";
import { ModalInputBox } from '../../components/Form/InputModal';
import {
  PublicVotingContainer,
  FilterContainer,
  NominationsList,
  NominationItem,
  NominationLogo,
  NominationInfo,
  VoteBtn,
  VotingModalContainer,
  VoteBtnsContainer,
  EmailVote,
  VoteWithEmailContainer,
  ErrorsList,
  ModalBody,
  SocialContainer,
  ShareLink,
  FooterText,
  FbLoginBtnContainer,
  FbLoginDescription
} from './styleComponents';
import Dropdown from 'react-dropdown';
import {
  CloseModal,
  confirmModelStyles,
  ErrorMessage,
  ModalTitle
} from '../../components/Form/styles';
import Modal from 'react-modal';
import EmailVotinForm from './EmailVotinForm';
import { IoIosClose } from 'react-icons/io';
import FacebookLogin from 'react-facebook-login';
import { SuccessImage } from '../PublicNomination';
import successImage from '../../images/success.png';
import unsuccessImage from '../../images/unsuccess.png';
import queryString from 'query-string';
import { FacebookShareButton, TwitterShareButton, FacebookIcon, TwitterIcon } from 'react-share';
import Helmet from 'react-helmet';
import ClipboardButton from '../../components/ClipboardButton';
import { withAlert } from 'react-alert';
import { Link } from 'react-router-dom';

const token = 'AuthToken';

class PublicVoting extends Component {
  constructor(props) {
    super(props);

    const queries = queryString.parse(props.location.search);

    this.state = {
      selectedCategory: null,
      selectedCountry: null,
      nominationName: '',
      votingModal: false,
      nominationVotingData: null,
      voteWithEmail: false,
      successModal: false,
      unsuccessModal: false,
      fbLoginModal: false,
      defaultNominationId: queries.nominationId || null,
      votingModalUniq: !!queries.nominationId
    };
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  setSearchName = debounce((value) => {
    this.setState({ nominationName: value });
  }, 1000);

  openModal = (modalType) => {
    this.setState({ [modalType]: true });
  };

  closeModal = (modalType) => {
    this.setState({
      [modalType]: false,
      nominationVotingData: null,
      voteWithEmail: false
    });
  };

  openVotingModal = (modalType, nomination) => {
    this.setState({
      nominationVotingData: nomination,
      isPrivacyPolicyChecked: false
    });
    this.openModal(modalType);
  };

  checkPrivacyPolicy = () => {
    this.setState((state) => ({
      isPrivacyPolicyChecked: !state.isPrivacyPolicyChecked,
      voteWithEmail: state.isPrivacyPolicyChecked ? false : state.voteWithEmail
    }));
  };

  toggleVoteWithEmail = () => {
    const { voteWithEmail } = this.state;

    this.setState({ voteWithEmail: !voteWithEmail });
  };

  submitEmailVoting = (data, emailPublicVote) => {
    const { nominationVotingData, defaultNominationId } = this.state;

    if (data && (nominationVotingData || defaultNominationId)) {
      emailPublicVote({
        variables: {
          vote: {
            name: data.name,
            email: data.email,
            nominationId: get(nominationVotingData, 'id', false)
              ? nominationVotingData.id
              : defaultNominationId
          }
        }
      })
        .then((res) => {
          if (res.data) {
            this.closeModal('votingModal');
            this.closeModal('votingModalUniq');
            this.openModal('successModal');
          }
        })
        .catch(() => {
          this.closeModal('votingModal');
          this.closeModal('votingModalUniq');
          this.openModal('unsuccessModal');
        });
    }
  };

  responseFacebook = (response, facebookPublicVote, nominationId) => {
    if (response.name || response.userID) {
      facebookPublicVote({
        variables: {
          vote: {
            name: response.name || '',
            email: response.email || null,
            nominationId: nominationId,
            userId: response.userID || ''
          }
        }
      })
        .then((res) => {
          if (res.data) {
            this.closeModal('votingModal');
            this.openModal('successModal');
          }
        })
        .catch(() => {
          this.closeModal('votingModal');
          this.openModal('unsuccessModal');
        });
    }
  };

  voteRemovalRedirect = (data) => {
    const {id, name} = data;
    const { competitionId } = this.props.match.params;
    const params = queryString.stringify({
      id,
      name,
      competitionId
    })

    window.location.assign( `${process.env.REACT_APP_FRONT_END_URL}/fb-vote-remove?${params}`) // eslint-disable-line
  }

  fbLoginModalContent = () => {
    const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;
    return (
      <VotingModalContainer>
        <Mutation mutation={FACEBOOK_PUBLIC_VOTE}>
          {(facebookPublicVote, { error }) => (
            <div>
              <FbLoginDescription>
                Please login with facebook to confirm your vote
              </FbLoginDescription>
              <FbLoginBtnContainer>
                <FacebookLogin
                  appId={facebookAppId}
                  autoLoad={false}
                  fields="name,email,picture"
                  callback={
                    this.voteRemovalRedirect
                  }
                  icon={<FaFacebookF size={20}/>}
                  isMobile={true}
                  disableMobileRedirect={true}
                />

              </FbLoginBtnContainer>
              <ErrorsList>
                {error &&
                  error.graphQLErrors.map(({ message }, i) => (
                    <ErrorMessage key={i}>{message}</ErrorMessage>
                  ))}
              </ErrorsList>
            </div>
          )}
        </Mutation>

        <Mutation mutation={FACEBOOK_PUBLIC_VOTE}>
          {(facebookPublicVote, { error }) => (
            <div>
              <ErrorsList>
                {error &&
                  error.graphQLErrors.map(({ message }, i) => (
                    <ErrorMessage key={i}>{message}</ErrorMessage>
                  ))}
              </ErrorsList>
            </div>
          )}
        </Mutation>
      </VotingModalContainer>
    );
  };

  votingModalContent = (nominationVotingData) => {
    const { voteWithEmail, isPrivacyPolicyChecked } = this.state;

    const prefixLink = process.env.REACT_APP_UPLOADED_FILES_LINK;
    const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;
    const competitionId = get(nominationVotingData, 'competitionId')
    return (
      <VotingModalContainer>
        {nominationVotingData && (
          <div>
            <NominationLogo>
              {get(nominationVotingData, 'logo.title', false) ? (
                <img
                  src={`${prefixLink}?file=${nominationVotingData.logo.title}&token=${token}`}
                  alt="Avatar"
                />
              ) : (
                <FaUser size={36}/>
              )}
            </NominationLogo>
            <NominationInfo>
              <span>Name:</span>{' '}
              {nominationVotingData.isCompanyNomination
                ? nominationVotingData.name
                : nominationVotingData.individualName}
            </NominationInfo>
            {nominationVotingData.webSite && (
              <NominationInfo>
                <span>Website:</span> {nominationVotingData.webSite}
              </NominationInfo>
            )}
            <NominationInfo>
              <span>Category:</span> {nominationVotingData.category.name}
            </NominationInfo>
            <NominationInfo>
              <span>Country:</span> {nominationVotingData.country.name}
            </NominationInfo>
          </div>
        )}
        <Mutation mutation={FACEBOOK_PUBLIC_VOTE}>
          {(facebookPublicVote, { error }) => (
            <div>
              <hr/>
              <label style={{ display: 'flex' }}>
                <input
                  style={{ marginLeft: '17px', marginTop: '3px' }}
                  type="checkbox"
                  value={isPrivacyPolicyChecked}
                  onClick={this.checkPrivacyPolicy}
                />
                <div className="terms">
                  I accept the
                  <Link to={`/privacy-policy?competitionId=${competitionId}`}> Terms and
                    Conditions, Privacy Policy </Link>
                  and I consent to receive email communication about GSA services.
                </div>
              </label>
              <VoteBtnsContainer>
                {(process.env.REACT_APP_IS_FACEBOOK_LOGIN_AVAILABLE === 'true') && (<FacebookLogin
                  appId={facebookAppId}
                  autoLoad={false}
                  fields="name,email,picture"
                  callback={(response) =>
                    this.responseFacebook(response, facebookPublicVote, nominationVotingData.id)}
                  icon={<FaFacebookF size={20}/>}
                  isMobile={true}
                  disableMobileRedirect={true}
                  isDisabled={!isPrivacyPolicyChecked}
                />)}

                <EmailVote
                  disabled={!isPrivacyPolicyChecked}
                  onClick={() => this.toggleVoteWithEmail()}
                >
                  <AiOutlineMail size={20}/>
                  Vote with email
                </EmailVote>
              </VoteBtnsContainer>
              <ErrorsList>
                {error &&
                  error.graphQLErrors.map(({ message }, i) => (
                    <ErrorMessage key={i}>{message}</ErrorMessage>
                  ))}
              </ErrorsList>
            </div>
          )}
        </Mutation>

        <Mutation mutation={FACEBOOK_PUBLIC_VOTE}>
          {(facebookPublicVote, { error }) => (
            <div>
              <ErrorsList>
                {error &&
                  error.graphQLErrors.map(({ message }, i) => (
                    <ErrorMessage key={i}>{message}</ErrorMessage>
                  ))}
              </ErrorsList>
            </div>
          )}
        </Mutation>
        {voteWithEmail && (
          <VoteWithEmailContainer>
            <Mutation mutation={EMAIL_PUBLIC_VOTE}>
              {(emailPublicVote, { error }) => (
                <div>
                  <EmailVotinForm
                    submitEmailVoting={this.submitEmailVoting}
                    emailPublicVote={emailPublicVote}
                  />
                  <ErrorsList>
                    {error &&
                      error.graphQLErrors.map(({ message }, i) => (
                        <ErrorMessage key={i}>{message}</ErrorMessage>
                      ))}
                  </ErrorsList>
                </div>
              )}
            </Mutation>
          </VoteWithEmailContainer>
        )}
      </VotingModalContainer>
    );
  };

  render() {
    const {
      match: { params },
      alert
    } = this.props;
    const {
      selectedCategory,
      nominationName,
      votingModal,
      successModal,
      unsuccessModal,
      defaultNominationId,
      votingModalUniq,
      nominationVotingData,
      selectedCountry,
      fbLoginModal,
    } = this.state;

    const competitionId = params.competitionId;
    const prefixLink = process.env.REACT_APP_UPLOADED_FILES_LINK;
    const rootUrlForShare = process.env.REACT_APP_PUBLIC_VOTING_PAGE;

    const shareUrl = `${rootUrlForShare}${competitionId}`;
    const title = "I've just voted at Global Startup Awards.";

    return (
      <PublicVotingContainer>
        <Query
          query={GET_COMPETITION_BY_ID}
          fetchPolicy="network-only"
          variables={{ id: competitionId || '' }}
        >
          {({ loading, error, data }) => {
            if (loading) return <div>Loading</div>;
            if (error) return <div>{error.message}</div>;
            const competitionName = get(data, 'publicGetCompetitionById.name', '');
            const categories = get(data, 'publicGetCompetitionById.categoriesList', []).map(
              (item) => renameObjectForSelect(item)
            );
            const countries = get(data, 'publicGetCompetitionById.countriesList', []).map((item) =>
              renameObjectForSelect(item)
            );

            return (
              <div>
                <Helmet
                  meta={[
                    {
                      name: 'description',
                      content: `${competitionName} - public voting round`
                    },
                    {
                      property: 'og:description',
                      content: `${competitionName} - public voting round`
                    }
                  ]}
                />
                <FilterContainer>
                  <div>
                    <span className="labelSpan">Filter by category</span>
                    <Dropdown
                      options={categories}
                      onChange={(value) => this.setState({ selectedCategory: value })}
                      value={selectedCategory}
                      placeholder={'Select category'}
                    />
                  </div>
                  <div>
                    <span className="labelSpan">Filter by country</span>
                    <Dropdown
                      options={countries}
                      onChange={(value) => this.setState({ selectedCountry: value })}
                      value={selectedCountry}
                      placeholder={'Select country'}
                    />
                  </div>
                  <ModalInputBox>
                    <label>
                      <span className="labelSpan">Filter by nomination name</span>
                      <input
                        type="text"
                        onChange={(data) => this.setSearchName(data.target.value)}
                        placeholder="Enter name..."
                      />
                    </label>
                  </ModalInputBox>
                  {(process.env.REACT_APP_IS_FACEBOOK_LOGIN_AVAILABLE === 'true') && <button
                    onClick={() => {
                        this.openModal('fbLoginModal');
                    }}>
                    <FaUser size={36}/>
                  </button>}
                </FilterContainer>

                <Query
                  query={GET_NOMINATIONS_FOR_PUBLIC_VOTING}
                  fetchPolicy="network-only"
                  variables={{
                    competitionId,
                    categoryId: get(selectedCategory, 'value', null),
                    countryId: get(selectedCountry, 'value', null),
                    nominationName,
                    defaultNominationId
                  }}
                >
                  {({ loading, error, data }) => {
                    if (loading && !get(data, 'getNominationsForPublicVoting', false))
                      return <div>Loading</div>;
                    if (error) return <div>{error.message}</div>;

                    const nominations = get(data, 'getNominationsForPublicVoting', []);

                    return (
                      <div>
                        {nominations.length > 0 ? (
                          <NominationsList>
                            {nominations.map((item) => (
                              <NominationItem key={item.id}>
                                <ShareLink>
                                  <ClipboardButton
                                    text={`${shareUrl}?nominationId=${item.id}`}
                                    copyWithAlert={() => alert.success('Link copied to clipboard')}
                                  >
                                    <FaShare/>
                                  </ClipboardButton>
                                </ShareLink>
                                <NominationLogo>
                                  {get(item, 'logo.title', false) ? (
                                    <img
                                      src={`${prefixLink}?file=${item.logo.title}&token=${token}`}
                                      alt="Avatar"
                                    />
                                  ) : (
                                    <FaUser size={36}/>
                                  )}
                                </NominationLogo>
                                <NominationInfo>
                                  <span>Name:</span>{' '}
                                  {item.isCompanyNomination ? item.name : item.individualName}
                                </NominationInfo>
                                {item.webSite && (
                                  <NominationInfo>
                                    <span>Website:</span> {item.webSite}
                                  </NominationInfo>
                                )}
                                <NominationInfo>
                                  <span>Category:</span> {item.category.name}
                                </NominationInfo>
                                <NominationInfo>
                                  <span>Country:</span> {item.country.name}
                                </NominationInfo>
                                <VoteBtn
                                  onClick={() => {
                                    this.openVotingModal('votingModal', { ...item, competitionId });
                                  }}
                                >
                                  Vote
                                </VoteBtn>
                              </NominationItem>
                            ))}
                          </NominationsList>
                        ) : (
                          <div>No results found. Please try to apply other filters.</div>
                        )}
                        <Modal
                          isOpen={votingModal}
                          onRequestClose={() => this.closeModal('votingModal')}
                          style={confirmModelStyles}
                          contentLabel="Voting modal"
                          animationDuration={500}
                        >
                          <CloseModal onClick={() => this.closeModal('votingModal')}>
                            <IoIosClose size="2.5em"/>
                          </CloseModal>
                          {this.votingModalContent(nominationVotingData)}
                        </Modal>

                        <Modal
                          isOpen={votingModalUniq}
                          onRequestClose={() => this.closeModal('votingModalUniq')}
                          style={confirmModelStyles}
                          contentLabel="Voting modal uniq"
                          animationDuration={500}
                        >
                          <CloseModal onClick={() => this.closeModal('votingModalUniq')}>
                            <IoIosClose size="2.5em"/>
                          </CloseModal>
                          <Query
                            query={GET_PUBLIC_NOMINATION_BY_ID}
                            fetchPolicy="network-only"
                            variables={{ id: defaultNominationId }}
                          >
                            {({ loading, error, data }) => {
                              if (loading) return <div>Loading</div>;
                              if (error) return <div>{error.message}</div>;
                              const nominationData = get(data, 'getPublicNominationById');

                              return <div>{this.votingModalContent(nominationData)}</div>;
                            }}
                          </Query>
                        </Modal>

                        <Modal
                          isOpen={successModal}
                          onRequestClose={() => this.closeModal('successModal')}
                          style={confirmModelStyles}
                          contentLabel="Success modal"
                          animationDuration={500}
                        >
                          <CloseModal onClick={() => this.closeModal('successModal')}>
                            <IoIosClose size="2.5em"/>
                          </CloseModal>
                          <SuccessImage src={successImage}/>
                          <ModalTitle>
                            Thank you! Your vote for {competitionName} was registered with success.
                            Fingers crossed!
                          </ModalTitle>
                          <FooterText>Don't forget to share</FooterText>
                          <SocialContainer>
                            <FacebookShareButton url={shareUrl} quote={title}>
                              <FacebookIcon size={36} round/>
                            </FacebookShareButton>
                            <TwitterShareButton url={shareUrl}>
                              <TwitterIcon size={36} round/>
                            </TwitterShareButton>
                          </SocialContainer>
                        </Modal>

                        <Modal
                          isOpen={unsuccessModal}
                          onRequestClose={() => this.closeModal('unsuccessModal')}
                          style={confirmModelStyles}
                          contentLabel="Unsuccess modal"
                          animationDuration={500}
                        >
                          <CloseModal onClick={() => this.closeModal('unsuccessModal')}>
                            <IoIosClose size="2.5em"/>
                          </CloseModal>
                          <SuccessImage src={unsuccessImage}/>
                          <ModalTitle>Ooops, something's not right.</ModalTitle>
                          <ModalBody>
                            <h4>Please check if:</h4>
                            <ul>
                              <li>
                                1- If you already voted for this contestant - You can only vote
                                once.
                              </li>
                              <li>
                                2- If it's the first time you try to vote - Try and reload the page
                              </li>
                              <li>
                                3- If the problem persists, or none of the above - Please send us
                                feedback on{' '}
                                <a href="mailto: nominations@globalstartupawards.com">
                                  nominations@globalstartupawards.com
                                </a>
                              </li>
                            </ul>
                          </ModalBody>
                        </Modal>

                        <Modal
                          isOpen={fbLoginModal}
                          onRequestClose={() => this.closeModal('fbLoginModal')}
                          style={confirmModelStyles}
                          contentLabel="Voting modal"
                          animationDuration={500}
                        >
                          <CloseModal onClick={() => this.closeModal('fbLoginModal')}>
                            <IoIosClose size="2.5em"/>
                          </CloseModal>
                          {this.fbLoginModalContent()}
                        </Modal>
                      </div>
                    );
                  }}
                </Query>
              </div>
            );
          }}
        </Query>
      </PublicVotingContainer>
    );
  }
}

export default compose(withAlert())(PublicVoting);
